// import BaseFormPresenter from "../../../../base/BaseFormPresenter";

import BaseFormPresenter from "../../../../components/common/BaseFormPresenter";

class OfficeFormPresenter extends BaseFormPresenter {
  onChangeObject(object) {
    this.change = object;
    this.object = object;
  }

  // showSuccess() {
  //   console.warn("SDFSDf");
  //   return this.showSuccess("WWWWWWWWWW");
  // }

  async save() {
    const collection = this.view.getCollectionName();
    if (this.object.id) {
      this.change.id = this.object.id;
    } else {
      this.change.acl = this.view.getAcl();
    }
    try {
      const region = this.view.getStateRegion();
      // console.warn("OFFICE: ", office);
      if (region === undefined) {
        throw new Error("Select Region");
      }
      this.change.region = region;
      this.change.name = this.view.state.name;
      this.change.description = this.view.state.description;
      this.change.status = "active";
      // this.showSuccess();
      // console.warn("DD: ", this.change);
      await this.upsertUseCase.execute(collection, this.change);
      this.showSuccess("Success");

      this.change = {};
    } catch (error) {
      throw error; // rethrow the error to be caught by the caller
    }
  }
}

export default OfficeFormPresenter;
